<template>
  <div id="contendor-principal-altaPagos" style="position:relative;">
    <div id="contenedor-encabezados-altaPagos" class="text-left">
      <h1>PAGOS</h1>
      <h3>Alta de pagos</h3>
    </div>
    <div id="contendor-principal-altaPagos" class="row mt-3">
      <transition name="fade">
        <div  id="contenedor-filtros-altaPagos" class="col-8">   
          <div v-if="(foliosSinImprimir != null && foliosSinImprimir.length > 0) || ultimoFolioNoImpreso != null">
            <PendientesImprimir
            :ultimoFolioNoImpreso="ultimoFolioNoImpreso"
            :foliosSinImprimir="foliosSinImprimir">
            
            </PendientesImprimir>
          </div>
          <div class="area_verde">
            <FiltrosDeBusqueda 
              @esAlPortador="esPortador"
              :catalogos="catalogos"
              :ejecutaLaFuncion="guardarPagoAPI"
              :AccionesMostrar="accionesMostrar"
              :AccionesPago="accionespago"
              :elementosAConservar="obtenerAreaDeUsuario"
              :folio="folio"
              :doc="TipoDocumentoID"
              :materia="materiaID"
              :quitarRubros="quitarRubros"
              :ref="'campoPago'">
          
            </FiltrosDeBusqueda>
          </div>
          <div v-if="Pagos != undefined && Pagos != null" id="Recibo" style="display: none;">
            <Recibo
              :folio="folio"
              :Pagos="Pagos"
              :ref="'datosRecibo'">
            </Recibo>
          </div>            
      </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import func from '../Comun/Funciones/comun.js'
  import FiltrosDeBusqueda from '@/components/SIVAC/Comun/FiltrosDeBusqueda.vue'
  import Recibo from '@/components/SIVAC/Caja/Recibo.vue'
  import PendientesImprimir from '@/components/SIVAC/Caja/PendientesImprimir.vue'
  import { servicioRestPost } from '../../Audiencias/Programacion/servicios/ServiciosHttp.js'

  export default{
    data(){
      return{
        enumeraciones,
        servicioRestPost,
        accionesMostrar:{
          pagos: true,
          firma: false,
          guardar: true,
          buscar: false
        },
        accionespago:{
          busqueda: false,
          alta: true,
        },
        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra_Firmas' },        
          { catalogoId: enumeraciones.catalogos.Rubros, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Rubro' }
        ],
        folio : null,
        TipoDocumentoID: null, //// cambiar a null si se necesita que sea abierto
        materiaID: null,////////////////////////////////////////////////////////////
        esAlPortador : false,
        Pagos: null,
        quitarRubros: [],
        foliosSinImprimir: null,
        ultimoFolioNoImpreso: null,
      }
    },
    computed:{

      obtenerAreaDeUsuario : function()
      {
        this.ultimoFolio();
        this.getFoliosSinImprimir(); 

         let ep = {  
           tiposDocumento: [1, 23, 26],
           areas: [95, 54, 53, 48, 52, 51, 12],
           partidosJudiciales: [1],
           materias: [6, 9]
         }
        return ep;
      }
    },
    components:{
      FiltrosDeBusqueda,
      Recibo,
      PendientesImprimir,
    },
    methods:{

      esPortador: function (p) {
        this.esAlPortador = p;
      },

      validarDatosBusquedaImputado: function(datos)
      {
        if(datos.Expediente.PartidoJudicialId == null || datos.Expediente.PartidoJudicialId == -1){
          comun.mensajeDeAlerta("Favor de indicar el partido judicial.", null, null);
          return false;
        }    
        if(datos.Expediente.AreaId == null || datos.Expediente.AreaId == -1) { //Verifica área
          comun.mensajeDeAlerta("Favor de indicar el área.", null, null);
          return false;
        }
        if(datos.Expediente.Consecutivo == null || datos.Expediente.Consecutivo == -1){
          comun.mensajeDeAlerta("Favor de indicar el consecutivo.", null, null);
          return false;
        }
        else if(datos.Expediente.Consecutivo.length < 9){
          comun.mensajeDeAlerta("Favor de indicar el consecutivo completo", null, null);
          return false;
        }
        if(datos.Expediente.MateriaId == null || datos.Expediente.MateriaId == -1) { //Verifica Materia
          comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
          return false;
        }
        if(datos.Expediente.TipoDocumentoId == null || datos.Expediente.TipoDocumentoId == -1) { //verifica tipo de documento
          comun.mensajeDeAlerta("Favor de indicar el tipo de documento.", null, null);
          return false;
        }
        if(datos.Rubro.TipoRubroId== null || datos.Rubro.TipoRubroId == -1){
          comun.mensajeDeAlerta("Favor de indicar el concepto", null, null);
          return false;
        }
        if(datos.Rubro.Monto<=0 || datos.Rubro.Monto == null){
          comun.mensajeDeAlerta("Favor de indicar un monto valido", null, null);
          return false;
        }  
        if(datos.Rubro.Telefono== null || datos.Rubro.Telefono == -1){
          comun.mensajeDeAlerta("Favor de indicar el telefono", null, null);
          return false;
        }
        if(datos.Rubro.Folio<=0 || datos.Rubro.Folio == null){
          comun.mensajeDeAlerta("Error al cargar el folio, recargue la pagina");
          return false;
        }
        if(datos.Persona.Nombre == null || datos.Persona.Nombre == undefined){
          comun.mensajeDeAlerta("Favor de indicar el nombre o si es al portador", null, null);
          return false;
        }
        if(datos.Rubro.Telefono.length < 10){
          comun.mensajeDeAlerta("El telefono debe tener al menos 10 digitos", null, null);
          return false;
        } 
        // if(datos.Persona.ApellidoPaterno == null || datos.Persona.ApellidoPaterno == undefined){
        //   comun.mensajeDeAlerta("Favor de indicar el apellido paterno", null, null);
        //   return false;
        // }
        // if(datos.Persona.ApellidoMaterno == null || datos.Persona.ApellidoMaterno == undefined){
        //   comun.mensajeDeAlerta("Favor de indicar el apellido materno", null, null);
        //   return false;
        // // }
        // if(datos.Expediente.CarpetaDeEjecucion == null || datos.Expediente.CarpetaDeEjecucion == -1){
        //   comun.mensajeDeAlerta("Favor de indicar el numero de carpeta de ejecucion.", null, null);
        //   return false;
        // // }
        // else if(datos.Expediente.CarpetaDeEjecucion.length < 9){
        //   comun.mensajeDeAlerta("Favor de indicar el numero de carpeta de ejecucion completo", null, null);
        //   return false;
        // }
        return true;
       },
      guardarPagoAPI:function() 
      { 
        const parametros = 
        {                  
          /////////////////////////campos expediente
          Expediente:{
            
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['campoPago'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['campoPago'].parametros_PartidoJudicial.partidoJudicialId : null,
            AreaId: this.campoRequeridoEsValido(this.$refs['campoPago'].parametros_Area.areaId) ? this.$refs['campoPago'].parametros_Area.areaId : null,
            MateriaId: this.campoRequeridoEsValido(this.$refs['campoPago'].parametros_Materia.materiaId) ? this.$refs['campoPago'].parametros_Materia.materiaId : null,
            TipoDocumentoId: this.campoRequeridoEsValido(this.$refs['campoPago'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['campoPago'].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(this.$refs['campoPago'].consecutivo) ? this.$refs['campoPago'].consecutivo : null,//cambiar a null cuando se cambie la base
            // CarpetaDeEjecucion: this.campoRequeridoEsValido(this.$refs['campoPago'].carpetadeejecucion) ? this.$refs['campoPago'].carpetadeejecucion :null,
            NumeroRomano: this.campoRequeridoEsValido(this.$refs['campoPago'].numeroRomano) ? this.$refs['campoPago'].numeroRomano : null
          },
          ///////////////////////campos pago
          Rubro:{
            Folio: this.campoRequeridoEsValido(this.folio) ? this.folio : null,
            TipoRubroId: this.campoRequeridoEsValido(this.$refs['campoPago'].parametros_Rubro.rubroId) ? this.$refs['campoPago'].parametros_Rubro.rubroId : null,
            Monto: this.campoRequeridoEsValido(this.$refs['campoPago'].monto) ? this.$refs['campoPago'].monto : null,
            Telefono: this.campoRequeridoEsValido(this.$refs['campoPago'].telefono) ? this.$refs['campoPago'].telefono : null,
            Observaciones: this.campoRequeridoEsValido(this.$refs['campoPago'].observaciones) ? this.$refs['campoPago'].observaciones : null
          },
          //////////////////////campos persona
          ...this.esAlPortador ? 
          {
            Persona:{
              Nombre: 'AL PORTADOR', ///empatar con el que aparece en pagos.vue
              ApellidoPaterno: null, 
              ApellidoMaterno: null
            }
          }:{ ///el false
            Persona:{
              Nombre:  this.campoRequeridoEsValido(this.$refs['campoPago'].nombre) ? this.$refs['campoPago'].nombre : null,
              ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['campoPago'].apellido_paterno) ? this.$refs['campoPago'].apellido_paterno : null,
              ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['campoPago'].apellido_materno) ? this.$refs['campoPago'].apellido_materno : null,
            }
          } 

          
        }

        if(this.validarDatosBusquedaImputado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.administracion.pagos.AltaPagos, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Pagos
              console.log(respuesta);
              this.Pagos = respuesta.data.Pagos;
              var altacaja = this;
              bootbox.dialog({
                title: "Mensaje del sistema",
                message: respuesta.data.Satisfactorio+ " Desea agregar otro concepto al pago?",
                buttons: {
                  cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No",
                    className: 'btn-danger float-right',
                    callback: function(){
                      altacaja.limpiarCamposAlta();
                      altacaja.imprimirRecibo(respuesta.data.folioActual);
                      altacaja.quitarRubros = [];
                    }

                  },
                  confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí",
                    className: 'btn-success',
                    callback: function(){
                      altacaja.$refs.campoPago.quitarRubros.push(altacaja.$refs.campoPago.parametros_Rubro.rubroId)
                      altacaja.agregarConcepto()
                    }
                  }
                }
              });
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },

      ultimoFolio:function(){
        const parametros = {};
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
        axios.post(api.conexion + api.SIVAC.sistema.administracion.pagos.GetUltimoFolio, parametros, headerPeticion)
        .then(respuesta => {
          comun.SeEstaCargandoInformacion(false);
          if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          }else{
            this.folio = respuesta.data.UltimoFolio;
          }
        })
        .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
        }); 
      },

      getFoliosSinImprimir:function(){
          const parametros = {};
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
          axios.post(api.conexion + api.SIVAC.sistema.administracion.pagos.GetFoliosSinImprimir, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }else{
              this.ultimoFolioNoImpreso = respuesta.data.ultimoFolioNoImpreso;
              this.foliosSinImprimir = respuesta.data.foliosSinImprimir;

            }
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          }); 
      },

      limpiarCamposAlta: function(){
        this.$refs.campoPago.limpiarFiltros();  
        this.ultimoFolio(); 
        this.getFoliosSinImprimir(); 
      },

      agregarConcepto:function() {
        this.$refs.campoPago.limpiarCamposAlta();
      },

      imprimirRecibo: async function(folio){
        //this.buscarImputadoFolio(folio);
        const parametros = 
        {  
          Folio: this.campoRequeridoEsValido(folio)  ?  folio : null                           
        }
          comun.SeEstaCargandoInformacion(true); 
         
          const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarPagos,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
          }));

          if(!RESPUESTA.Error) {
            //Cargar Datos de Pagos
            this.Pagos = RESPUESTA.Pagos;

            this.cargarMensajeImprimirRecibo(folio);
          }
          else{              
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
          }

        },

        cargarMensajeImprimirRecibo: function(folio){
          this.$nextTick(() => {
            var altacaja = this;
            var recibo = altacaja.Pagos[0]
            var pagoGeneral = recibo;
            var nombre = recibo.Nombre + ' ' +  ((recibo.ApellidoPaterno != null) ? recibo.ApellidoPaterno : '') + ' ' + ((recibo.ApellidoMaterno != null) ?  recibo.ApellidoMaterno : '');
            var conceptos = "";

            altacaja.Pagos.forEach((Pago) =>{
                
                  conceptos += ("" + Pago.RubroDBPJ.Nombre + ": $" + this.agregarCeros(Pago.Monto) + "<br>");
                
            });

            bootbox.dialog({
              title: "Mensaje del sistema",
              message: "Desea imprimir el recibo? Al presionar Si ya no se podra hacer ninguna modificacion <br><br>" + 
                   "Juzgado: " + pagoGeneral.Expediente.Area.Nombre + "<br>" + 
                   "Consecutivo: " + pagoGeneral.Expediente.Consecutivo + ((pagoGeneral.Expediente.NumeroRomano != null) ? '-' + pagoGeneral.Expediente.NumeroRomano : '') +"<br>" + 
                   "Tipo Doc: " + pagoGeneral.Expediente.TipoDocumento.Nombre+"<br>" + 
                   "Nombre: " + nombre + "<br>" +
                   "Telefono: " + pagoGeneral.Telefono + "<br>" +
                   (pagoGeneral.Observaciones ? "Observaciones: " + pagoGeneral.Observaciones + "<br>" : '')  +
                   "<br>Conceptos: " + "<br>" + conceptos + "<br>",
              buttons: {
                cancel: {
                  label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No",
                  className: 'btn-danger float-right',
                    callback: function(){
                      altacaja.$refs['campoPago'].limpiarFiltros();
                    //console.log(altacaja)
                    }

                },
                confirm: {
                  label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí",
                  className: 'btn-success',
                    callback: function(){
                      altacaja.$refs['datosRecibo'].imprimirRecibo(folio);
                    }
                }
              }
            });
          });
        },

      campoRequeridoEsValido: function(campo) 
      {

          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      agregarCeros : function(monto){
          return func.agregarCeros(monto)
      },

    }
  }

</script>


<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style>
  
.modal-footer {
  display: inline;
}
.area_verde{
  background-color: var(--verde-pj);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Administracion/AltaCaja.vue